import Vue from 'vue'
import Router from 'vue-router'
import CharacterSheet from '@/components/CharacterSheet'
import Index from '@/components/Index'
import Catchall from '@/components/Catchall'
import LoginCallback from '@/components/LoginCallback'
import LogoutCallback from '@/components/LogoutCallback'
import OGL from '@/components/OGL'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/dnd/character-sheet',
      name: 'CharacterSheet',
      component: CharacterSheet
    },
    // {
    //   path: '/dnd/character-sheet/:id',
    //   name: 'CharacterSheet',
    //   component: CharacterSheet
    // },
    {
      path: '/dnd/ogl',
      name: 'OGL',
      component: OGL
    },
    {
      path: '/login/callback',
      name: 'LoginCallback',
      component: LoginCallback
    },
    {
      path: '/logout/callback',
      name: 'LogoutCallback',
      component: LogoutCallback
    },
    {
      path: '*',
      name: 'Catchall',
      component: Catchall
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js